// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitor-list_monitor-list_ZSvod {
  /* Width/height are set by the component, margin: auto centers in fullscreen */
  margin: auto;
  pointer-events: none;
  overflow: hidden;
}

.monitor-list_monitor-list-scaler_pM2o5 {
  /* Scaling for monitors should happen from the top left */
  transform-origin: left top;
}

::-ms-clear {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/monitor-list/monitor-list.css"],"names":[],"mappings":"AAAA;EACE,8EAA8E;EAC9E,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".monitor-list {\n  /* Width/height are set by the component, margin: auto centers in fullscreen */\n  margin: auto;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.monitor-list-scaler {\n  /* Scaling for monitors should happen from the top left */\n  transform-origin: left top;\n}\n\n::-ms-clear {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monitor-list": `monitor-list_monitor-list_ZSvod`,
	"monitorList": `monitor-list_monitor-list_ZSvod`,
	"monitor-list-scaler": `monitor-list_monitor-list-scaler_pM2o5`,
	"monitorListScaler": `monitor-list_monitor-list-scaler_pM2o5`
};
export default ___CSS_LOADER_EXPORT___;
